"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.maxDate = exports.minDate = exports.dateAggregate = void 0;
const flattenDeep_1 = __importDefault(require("lodash-es/flattenDeep"));
const field_logic_1 = require("../field-type-registry/field-logic");
const date_1 = require("../utils/date");
function dateAggregate(aggregate) {
    return (0, field_logic_1.valuesAggregator)((values, logic, field, userPreferences) => {
        // TODO: The Lookup field uses this aggregations without modifications. It is necessary to
        //  rewrite receiving aggregations through a function as receiving filtering functions (getComparisons).
        //  Move logic flatten to Lookup field logic
        const dates = (0, flattenDeep_1.default)(values)
            .filter((value) => !logic.isValueEmpty(value, field))
            .map((date) => ({
            date,
            momentDate: (0, date_1.dateToMoment)(date, userPreferences),
        }));
        return aggregate(dates, field, userPreferences, field.params.display_format, field.params.timezone, field.params.display_timezone, field.params.date_format, field.params.time_format);
    });
}
exports.dateAggregate = dateAggregate;
const minDate = (dates, field, userPreferences, displayFormat, timezone, displayTimezone, dateFormat, timeFormat) => {
    const { date } = dates.reduce((acc, value) => !(acc === null || acc === void 0 ? void 0 : acc.momentDate) || acc.momentDate > value.momentDate ? value : acc, {});
    if (!date) {
        return "";
    }
    return (0, date_1.formatDateValueToDisplayFormat)(date, userPreferences, displayFormat, timezone, displayTimezone, dateFormat, timeFormat);
};
exports.minDate = minDate;
const maxDate = (dates, field, userPreferences, displayFormat, timezone, displayTimezone, dateFormat, timeFormat) => {
    const { date } = dates.reduce((acc, value) => !(acc === null || acc === void 0 ? void 0 : acc.momentDate) || acc.momentDate < value.momentDate ? value : acc, {});
    if (!date) {
        return "";
    }
    return (0, date_1.formatDateValueToDisplayFormat)(date, userPreferences, displayFormat, timezone, displayTimezone, dateFormat, timeFormat);
};
exports.maxDate = maxDate;
